export const multiValuesFor = (predicate)=>{
    if (predicate.in != null && predicate.in.length > 1) return predicate.in;
    if (predicate.nin != null && predicate.nin.length > 1) return predicate.nin;
    return null;
};
export const isExcludeMode = (predicate)=>predicate.neq != null || predicate.nin != null;
export const isEmptyPredicate = (predicate)=>predicate.in == null && predicate.nin == null && predicate.eq == null && predicate.neq == null && predicate.gte == null && predicate.lte == null && predicate.gt == null && predicate.lt == null;
const negatedValueLabel = (value, texts)=>texts.valueIsNot != null ? texts.valueIsNot(value) : "≠".concat(texts.valueIs(value));
export const valueSegmentLabels = (predicate, texts)=>{
    const values = multiValuesFor(predicate);
    if (values == null) return null;
    return isExcludeMode(predicate) ? values.map((value)=>negatedValueLabel(value, texts)) : values.map((value)=>texts.valueIs(value));
};
export const valueLabelFor = (predicate, texts)=>{
    if (predicate.in != null && predicate.in.length === 1) return texts.valueIs(predicate.in[0]);
    if (predicate.nin != null && predicate.nin.length === 1) return negatedValueLabel(predicate.nin[0], texts);
    if (predicate.eq != null) return texts.valueIs(predicate.eq);
    if (predicate.neq != null) return negatedValueLabel(predicate.neq, texts);
    if (predicate.gte != null && predicate.lte != null) return texts.valueIs("".concat(predicate.gte, "–").concat(predicate.lte));
    const lowerBound = predicate.gte != null ? "≥".concat(predicate.gte) : predicate.gt != null ? ">".concat(predicate.gt) : null;
    const upperBound = predicate.lte != null ? "≤".concat(predicate.lte) : predicate.lt != null ? "<".concat(predicate.lt) : null;
    if (lowerBound != null && upperBound != null) return texts.valueIs("".concat(lowerBound, " ").concat(upperBound));
    if (predicate.gt != null && predicate.gte == null) return texts.valueOver(predicate.gt);
    if (predicate.lt != null && predicate.lte == null) return texts.valueUnder(predicate.lt);
    if (lowerBound != null) return texts.valueIs(lowerBound);
    if (upperBound != null) return texts.valueIs(upperBound);
    return texts.label;
};
export const initialFieldValue = (predicate)=>{
    if (predicate.eq != null) return String(predicate.eq);
    if (predicate.neq != null) return String(predicate.neq);
    if (predicate.in != null && predicate.in.length === 1) return String(predicate.in[0]);
    if (predicate.nin != null && predicate.nin.length === 1) return String(predicate.nin[0]);
    return '';
};
export const isRangeModeOnly = (predicate)=>predicate.in == null && predicate.nin == null && predicate.eq == null && predicate.neq == null && (predicate.gte != null || predicate.lte != null || predicate.lt != null || predicate.gt != null);
const MAX_INT_RANGE_ITEMS = 100;
export const parseNumbers = (value)=>{
    const tokens = value.split(/[,]|\bor\b/).map((token)=>token.trim()).filter((token)=>token.length > 0);
    if (tokens.length > MAX_INT_RANGE_ITEMS) return null;
    const numbers = tokens.map(Number);
    if (numbers.some((n)=>!Number.isInteger(n) || n < 0)) return null;
    return numbers;
};
export const predicateFromNumbers = (numbers, isExclude)=>{
    if (numbers.length === 0) return undefined;
    if (numbers.length === 1) return isExclude ? {
        neq: numbers[0]
    } : {
        eq: numbers[0]
    };
    return isExclude ? {
        nin: numbers
    } : {
        in: numbers
    };
};
export const editableValue = (predicate)=>{
    const multi = multiValuesFor(predicate);
    return multi != null ? multi.join(', ') : initialFieldValue(predicate);
};
